import { TTranslationFunction } from '@/types'

import { transformBackendResponseKey } from '../../../../config/i18n/translationRequestHelpers'

const MISSING_REQUIRED_DETAILS_KEY =
	'api.errors.clients.qr-codes.qrCodeMissingRequiredDetails'

const FALLBACK_KEY = 'public__backend_save_error'

const isNameError = (message: unknown): message is string =>
	typeof message === 'string' && /^name\b/.test(message)

export const getQrNameErrorMessage = (
	error: unknown,
	t: TTranslationFunction,
): string => {
	const message = (error as { response?: { data?: { message?: unknown } } })
		?.response?.data?.message

	if (Array.isArray(message) && message.length > 0) {
		const nameError = message.find(isNameError)

		return (
			nameError ??
			t(transformBackendResponseKey(MISSING_REQUIRED_DETAILS_KEY))
		)
	}

	if (typeof message === 'string' && message) {
		return t(transformBackendResponseKey(message))
	}

	return t(FALLBACK_KEY)
}
